import { useState, type FormEvent } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useLogin, useMe } from '../api/staff.js';
import { ErrorText } from '../components/ErrorText.js';
import { t } from '../i18n/uk.js';

export function LoginPage() {
  const me = useMe();
  const login = useLogin();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  if (me.data) return <Navigate to={from} replace />;

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate({ email, password });
  };

  return (
    <main className="login">
      <form className="card login-card" onSubmit={submit}>
        <h1 className="brand">{t.login.title}</h1>
        <label>
          {t.login.email}
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          {t.login.password}
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <ErrorText error={login.error} />
        <button type="submit" className="primary" disabled={login.isPending}>
          {login.isPending ? t.login.submitting : t.login.submit}
        </button>
      </form>
    </main>
  );
}
